import React, { Component } from 'react'
import HeaderUserInfoView from '../component/HeaderUserInfoView'
import { authorization } from '../../../../Module/Auth/Auth'
import { roleLabel } from '../../../../Containers/UserManagement/UserListTableLegacy'
import { getReadableRoleByUser } from '../../../../Containers/UserManagement/UserDetails/utils'
export default class HeaderUserInfo extends Component {
  state = {
    userName: 'Promofy',
    userRole: '',
    dropDownOpened: false,
  }

  componentDidMount() {
    const user = authorization.getUser()
    const { firstName, lastName } = user

    const role = roleLabel[getReadableRoleByUser(user)]

    this.setState({
      userName: `${firstName} ${lastName}`,
      userRole: role,
    })
  }

  toggleDropDown = () => {
    this.setState({ dropDownOpened: !this.state.dropDownOpened })
  }

  render() {
    const { userName, userRole, dropDownOpened } = this.state
    return (
      <HeaderUserInfoView
        name={userName}
        role={userRole}
        dropDownOpened={dropDownOpened}
        toggleDropDown={this.toggleDropDown}
      />
    )
  }
}
